export default {
      id: "ship-usage",
      viewBox: "0 0 640 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#ship",
      toString: function () {
        return this.url;
      }
    }